const BACKEND = {
  IMPORT_EXPORT_ORCHESTRATOR: 'importExportOrchestrator',
  DATAWS: 'dataws'
}

function getBackend(exportConfig) {
  return (exportConfig && exportConfig.backend) || BACKEND.DATAWS
}

function usesImportExportOrchestrator(exportConfig) {
  return getBackend(exportConfig) === BACKEND.IMPORT_EXPORT_ORCHESTRATOR
}

export default {
  BACKEND,
  getBackend,
  usesImportExportOrchestrator
}
